import {formatStatus} from "./TextFormatter";

export function formatSalesOrderStatus(status) {
  switch(status) {
    case "authentication_required":
      return "Auth Required";
    default:
      return formatStatus(status);
  }
}


export function formatStatusForMessage(status) {
  switch(status) {
    case "waiting": 
      return "still awaiting payment";

    case "billed":
      return "billed but payment has not been recorded";

    case "authentication_required":
      return "requiring authentication";

    default:
      return status;
  }
}